import { render, staticRenderFns } from "./NaverPayGuide.vue?vue&type=template&id=678e516c&"
import script from "./NaverPayGuide.vue?vue&type=script&lang=ts&"
export * from "./NaverPayGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports